import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.match";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import config from "./config";
import atom from '@tencent/vft-atom';
export var canGetInstallState = true;
export function ready() {
  return new Promise(function (resolve) {
    if (window.TenvideoJSBridge) {
      resolve();
    } else {
      document.addEventListener('onTenvideoJSBridgeReady', function () {
        resolve();
      }, false);
    }
  });
}
export function getInstallState() {
  return _getInstallState.apply(this, arguments);
}

function _getInstallState() {
  _getInstallState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var conf,
        _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            conf = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : config;
            _context2.next = 3;
            return ready();

          case 3:
            if (!conf.packageUrl.match(/^(tenvideo2|txvideo):\/\//)) {
              _context2.next = 7;
              break;
            }

            return _context2.abrupt("return", true);

          case 7:
            return _context2.abrupt("return", new Promise( /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve) {
                var _yield$atom$invoke, installed;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return atom.invoke('isInstalled', {
                          pkgName: conf.packageName,
                          pkgUrl: conf.packageUrl
                        });

                      case 2:
                        _yield$atom$invoke = _context.sent;
                        installed = _yield$atom$invoke.installed;
                        resolve(installed);

                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x2) {
                return _ref.apply(this, arguments);
              };
            }()));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getInstallState.apply(this, arguments);
}

export function launch(_x) {
  return _launch.apply(this, arguments);
}

function _launch() {
  _launch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(schemeUrl) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return ready();

          case 2:
            location.href = schemeUrl;
            return _context3.abrupt("return", true);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _launch.apply(this, arguments);
}

export function download() {
  return _download.apply(this, arguments);
}

function _download() {
  _download = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            throw new Error('in tenvideo');

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _download.apply(this, arguments);
}

export default {
  canGetInstallState: canGetInstallState,
  ready: ready,
  getInstallState: getInstallState,
  launch: launch,
  download: download
};